import t from "utils/translate";
import cx from "classnames";
import styles from "./styles.module.scss";

interface OfferTagProps {
  headline: string;
  details?: string;
  priceCrossout?: string;
  price?: string;
}

const OfferTag = ({
  headline,
  details,
  priceCrossout,
  price
}: OfferTagProps): JSX.Element => {
  return (
    <div className={styles.offer}>
      <div className={styles.tag}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="17"
          fill="none"
        >
          <path
            fill="#0D9488"
            fillRule="evenodd"
            d="M2.5 0A2.5 2.5 0 0 0 0 2.5v3.879a2.5 2.5 0 0 0 .732 1.767l7.5 7.5a2.5 2.5 0 0 0 3.536 0l3.878-3.878a2.502 2.502 0 0 0 0-3.536l-7.5-7.5A2.5 2.5 0 0 0 6.38 0H2.5ZM3 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
            clipRule="evenodd"
          />
        </svg>
      </div>
      <div
        className={cx(styles.offerDetails, { [styles.hasDetails]: details })}
      >
        <div className={styles.headline}>{t(headline)}</div>
        {details && <div className={styles.details}>{t(details)}</div>}
        {(price || priceCrossout) && (
          <span className={styles.priceWrapper}>
            {priceCrossout && (
              <span className={styles.priceCrossout}>{priceCrossout}</span>
            )}
            {price && <span className={styles.price}>{price}</span>}
          </span>
        )}
      </div>
    </div>
  );
};

export default OfferTag;
